import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useAccount } from '../contexts/AccountContext';

// `requireAdmin` guards the CREATE routes — new vault, new app, new sync project. Creating a product is
// an admin act ('A' on the property, its chain or its partner; superadmin bypasses), and the lambdas
// enforce the same rule, so this exists to stop someone being walked through a wizard that can only end
// in a 403. It is not the security boundary; the API is.
const PrivateRoute = ({ children, requireSuperAdmin = false, requireAdmin = false }) => {
  const { isAuthenticated, isSuperAdmin, loading } = useAuth();
  const { canCreateProducts, canCreateProductsLoaded } = useAccount();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Superadmin-only routes (Admin menu): an authenticated non-superadmin who
  // navigates here directly by URL is bounced to the dashboard.
  if (requireSuperAdmin && !isSuperAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireAdmin && !canCreateProductsLoaded) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (requireAdmin && !canCreateProducts) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;
